import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=0b8f5bb1&"
import script from "./PackageCard.vue?vue&type=script&lang=js&"
export * from "./PackageCard.vue?vue&type=script&lang=js&"
import style0 from "./PackageCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports